module.exports = __webpack_public_path__ + "static/media/phone.f87ba69e.svg";